import { Route } from "@angular/router";
import { UserListComponent } from "./user-list.component";

export const UserListRouting : Route = {
    path: 'list',
    component: UserListComponent,
    data: {
        breadcrumb: "Liste"
    }
}
